// src/js/context/AuthContext.ts
import { globalState } from "../framework/globalState.ts";
import { logout as apiLogout } from "../services/api.ts";
import type { IUser, IAuthContext } from '../types/index.ts';

export const authContext: IAuthContext = {
  login(user: IUser, token: string): void {
    globalState.user = user;
    globalState.token = token;
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("token", token);
  },
  logout(): void {
    apiLogout();
    globalState.user = null;
    globalState.token = null;
    // localStorage.removeItem("user");
    // localStorage.removeItem("token");
  },
  get isLoggedIn(): boolean {
    return !!(globalState.user && globalState.token);
  }
};
